import { PropertyMatrixSharedService } from 'src/app/property-matrix-shared.service';
import { UserService } from 'src/app/services/user.service';
import { Component, OnInit } from '@angular/core';
import { User } from 'src/app/models/User';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-home-dialog-popup',
    templateUrl: './home-dialog.component.html',
    styleUrls: ['./home-dialog.component.scss']
})
export class HomeDialogComponent implements OnInit {

    user: User;

    constructor(
        private userService: UserService,
        private authService: PropertyMatrixSharedService,
        public dialogRef: MatDialogRef<HomeDialogComponent>,
    ) { }

    ngOnInit() { }

    closeDialog(): void {
        this.dialogRef.close();
    }
}